export default "__VITE_PUBLIC_ASSET__6c5929a7__"